import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

import Container from '../layout/Container';

const Background = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.colours.backgroundPaper};
`;

const Inner = styled(Container)`
  padding-bottom: 0;
`;

const Title = styled.p`
  && {
    text-align: center;
    line-height: 1.7;
    margin: 0 auto ${({ theme }) => theme.sizes.lvl6};
    max-width: 59rem;
    font-size: ${({ theme }) => theme.font.sizes.lg};
    font-weight: 400;
    ${({ theme }) => theme.breakpoint('tabletLandscape')`
      line-height: 1.4;
      font-size: ${({ theme }) => theme.font.sizes.xxxl};
    `}
    u {
      text-underline-position: under;
    }
    strong {
      font-weight: 700;
    }
  }
`;
const ImageContainer = styled.div`
  z-index: 1;
  margin-bottom: -${({ theme }) => theme.sizes.lvl10};
  padding: 0 ${({ theme }) => theme.sizes.lvl4};
  max-width: ${({ theme }) => theme.sizes.sizeByFactor(48)};
`;

const Columns = styled.div`
  display: flex;
  align-items: center;
`;
const Content = styled.ul`
  flex: 1;
  li {
    color: rgba(0, 0, 0, 0.7);
    position: relative;
    list-style-type: none;
    padding-left: ${({ theme }) => theme.sizes.lvl14};
    margin-bottom: ${({ theme }) => theme.sizes.lvl8};
    &:before {
      content: 'question_mark';
      font-family: 'Material Icons';
      font-size: 2rem;
      width: ${({ theme }) => theme.sizes.lvl8};
      height: ${({ theme }) => theme.sizes.lvl8};
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background-color: ${({ theme }) => theme.colours.tertiary};
      color: ${({ theme }) => theme.colours.white};
    }
  }
`;

const FeaturedGiftSection = () => {
  return (
    <Background>
      <Inner>
        <Title>
          Do you struggle with <u>tiredness</u>, <u>lethargy</u> or a total{' '}
          <u>lack of energy</u>?
        </Title>
        <Columns>
          <Content>
            <li>
              Do you suffer with chronic fatigue, ME/CFS, Fibromyalgia,
              long-COVID or another fatigue-related condition?
            </li>
            <li>
              Would you like to understand how you can start to re-gain your
              energy and map your path to a healthier and happier life?
            </li>
          </Content>
          <ImageContainer>
            <StaticImage
              alt="Featured gift image"
              src="../images/featuredgift.png"
            />
          </ImageContainer>
          <Content>
            <li>
              Do you feel alone and misunderstood by your friends, family and
              medical professionals?
            </li>
            <li>
              Would you like to be inspired by those who have been in similar
              situations and recovered?
            </li>
          </Content>
        </Columns>
      </Inner>
    </Background>
  );
};

export default FeaturedGiftSection;
